class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.timerStartYear = this.getAttribute('data-timer-start-year');
    this.timerStartMonth = this.getAttribute('data-timer-start-month');
    this.timerStartDay = this.getAttribute('data-timer-start-day');
    this.timerStartHour = this.getAttribute('data-timer-start-hour');
    const startDate = new Date(this.timerStartYear, this.timerStartMonth - 1, this.timerStartDay, this.timerStartHour);

    this.timerEndYear = this.getAttribute('data-timer-end-year');
    this.timerEndMonth = this.getAttribute('data-timer-end-month');
    this.timerEndDay = this.getAttribute('data-timer-end-day');
    this.timerEndHour = this.getAttribute('data-timer-end-hour');
    const endDate = new Date(this.timerEndYear, this.timerEndMonth - 1, this.timerEndDay, this.timerEndHour);

    const now = new Date();

    if (startDate > now || endDate < now)
      return;

    document.getElementById(this.getAttribute('data-container-id')).style.display = 'block';

    this.timerStartInterval = setInterval(() => {
      this.remainingTime = this.calculateRemainingTime();
      this.updateTimer();
    }, 1000);
  }

  calculateRemainingTime() {
    const now = new Date();
    const endDate = new Date(this.timerEndYear, this.timerEndMonth - 1, this.timerEndDay, this.timerEndHour);
    return endDate - now;
  }

  updateTimer() {
    const days = Math.floor(this.remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor((this.remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((this.remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((this.remainingTime % (1000 * 60)) / 1000);

    this.querySelector('.keetsa-countdown-timer__days-value').textContent = days;
    this.querySelector('.keetsa-countdown-timer__hours-value').textContent = hours;
    this.querySelector('.keetsa-countdown-timer__minutes-value').textContent = minutes;
    this.querySelector('.keetsa-countdown-timer__seconds-value').textContent = seconds;
  }

}

customElements.define('countdown-timer', CountdownTimer);
